"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    stage: "prod",
    photomapsApi: {
        url: "https://aghn4sgrgl.execute-api.us-east-1.amazonaws.com/prod"
    },
    aws: {
        region: "us-east-1",
        cognito: {
            userPoolId: "us-east-1_uNNqXyL4q",
            appClientId: "5rrfre7ntbe10r48olndhcn60t",
            identityPoolId: "us-east-1:cfbb50df-d7a8-4dfe-b1fb-da637cb66a9a",
        },
    },
    shopify: {
        domain: "photomaps-com.myshopify.com",
        storefrontAccessToken: "819d35b9368de95c36bcd89f7e3138a9",
    },
};
exports.default = config;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGhvdG9tYXBzRG90Q29tQ29uZmlnLnByb2QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvUGhvdG9tYXBzRG90Q29tQ29uZmlnLnByb2QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFNLE1BQU0sR0FBMEI7SUFDcEMsS0FBSyxFQUFFLE1BQU07SUFDYixZQUFZLEVBQUU7UUFDWixHQUFHLEVBQUUsNkRBQTZEO0tBQ25FO0lBQ0QsR0FBRyxFQUFFO1FBQ0gsTUFBTSxFQUFFLFdBQVc7UUFDbkIsT0FBTyxFQUFFO1lBQ1AsVUFBVSxFQUFFLHFCQUFxQjtZQUNqQyxXQUFXLEVBQUUsNEJBQTRCO1lBQ3pDLGNBQWMsRUFBRSxnREFBZ0Q7U0FDakU7S0FDRjtJQUNELE9BQU8sRUFBRTtRQUNQLE1BQU0sRUFBRSw2QkFBNkI7UUFDckMscUJBQXFCLEVBQUUsa0NBQWtDO0tBQzFEO0NBQ0YsQ0FBQztBQUNGLGtCQUFlLE1BQU0sQ0FBQyJ9